import { render, staticRenderFns } from "./InformeAuditoriaFieldBoolean.vue?vue&type=template&id=fd053048&"
import script from "./InformeAuditoriaFieldBoolean.vue?vue&type=script&lang=js&"
export * from "./InformeAuditoriaFieldBoolean.vue?vue&type=script&lang=js&"
import style0 from "./InformeAuditoriaFieldBoolean.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VChip } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VImg } from 'vuetify/lib'
import { VRadio } from 'vuetify/lib'
import { VRadioGroup } from 'vuetify/lib'
import { VSelect } from 'vuetify/lib'
import { VTextarea } from 'vuetify/lib'
import { VTooltip } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VCardText,
  VCardTitle,
  VChip,
  VDataTable,
  VFlex,
  VIcon,
  VImg,
  VRadio,
  VRadioGroup,
  VSelect,
  VTextarea,
  VTooltip,
})
